module.exports = __webpack_public_path__ + "b506f2be308f6f5144f992c1f4ba8b18.svg";